(function() {
  const forms = document.querySelectorAll("form");

  forms.forEach((form) => {
    form.addEventListener("submit", () => {
      const submitButton = form.querySelector(".customer-loading-button");

      if (submitButton) {
        submitButton.classList.add("loading");
      }
    });
  });
})();